import axios from "axios";
export function getUserInfo(memberUrl) {
    return axios.post(memberUrl + "/member/login/checkLogin.html")
}